import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { ProductForm } from './ProductForm';
import { Product, ProductFormData } from '../types/product.types';

interface ProductModalProps {
  isOpen: boolean;
  product: Product | null;
  onSave: (data: ProductFormData) => void;
  onClose: () => void;
}

export const ProductModal: React.FC<ProductModalProps> = ({
  isOpen,
  product,
  onSave,
  onClose,
}) => {
  const title = product ? 'Editar Producto' : 'Nuevo Producto';

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <ProductForm
          product={product}
          onSave={onSave}
          onCancel={onClose}
        />
      </DialogContent>
    </Dialog>
  );
};